import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { OneFormProjectCard } from '../Project/OneFormProjectCard';
import { ProjectActionCreators, AppActionCreators } from '../../../actions';
import { DistrictDropdownOption, ProjectType } from '../../../utils/enums';
import { RouteUrls } from '../../../configs/routeUrls';

class SurveyCardVoteContainer extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		let { id } = this.props.match.params;
		if (id) {
			this.props.getProject(id);
		}
		this.props.setBreadcrumbs([
			{
				url: RouteUrls.Survey.list.actual,
				displayName: 'Ankiety'
			},
			{
				url: RouteUrls.Survey.voteFunc(id),
				displayName: 'Ankieta'
			}
		]);
	}

	render() {
		const {
			isAuth,
			isProjectLoading,
			isOnlyOneOffice,
			loggedUserId,
			opinionExecuting,
			voteExecuting,
			loggedUserIsCitizen,
			loggedUserOfficeId,
			loggedDistrictId,
			externalSystemAddress
		} = this.props;

		return (
			<OneFormProjectCard
				{...this.props.project}
				consultationTitle="Ankieta"
				type={ProjectType.Survey}
				disabled={false}
				isAuth={isAuth}
				isProjectLoading={isProjectLoading}
				isOnlyOneOffice={isOnlyOneOffice}
				loggedUserId={loggedUserId != null ? loggedUserId : 0}
				loggedUserOfficeId={loggedUserOfficeId}
				loggedDistrictId={loggedDistrictId ? loggedDistrictId : DistrictDropdownOption.NotSetted}
				loggedUserIsCitizen={loggedUserIsCitizen}
				opinionExecuting={opinionExecuting}
				voteExecuting={voteExecuting}
				externalSystemAddress={externalSystemAddress}
				saveAnswers={this.props.updateConsultationForm}
				onCancel={this.props.goBack}
				isPreview={false}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isAuth: state.app.isAuth,
		isProjectLoading: state.project.isProjectLoading,
		isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
		opinionExecuting: state.project.opinionExecuting,
		voteExecuting: state.project.voteExecuting,
		project: state.project.project,
		loggedUserId: state.app.loggedUser.userId,
		loggedUserOfficeId: state.app.loggedUser.officeId,
		loggedDistrictId: state.app.loggedUser.districtId || DistrictDropdownOption.NotSetted,
		loggedUserIsCitizen: state.app.loggedUser.isCitizen || false,
		externalSystemAddress: state.app.officeFooter.eboi || '',
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators({ ...ProjectActionCreators, ...AppActionCreators }, dispatch),
		...{
			goBack: () => dispatch(goBack())
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyCardVoteContainer);
